import styled from 'styled-components';

const percentageSize = 1.3;

export const CleanLlegendaSvg = styled.svg.attrs((props) => ({
  xmlns: 'http://www.w3.org/2000/svg',
  version: '1.1',
  viewBox: '0 0 512 512',
  width: props.fontSizeEnabled ? 22 * percentageSize : 22,
  height: props.fontSizeEnabled ? 22 * percentageSize : 22,
  fill: window.innerWidth > 768 ? (props.isHover ? '#febf00' : 'white') : 'white'
}))``;

export const ExpandLlegendaSvg = styled.svg.attrs((props) => ({
  xmlns: 'http://www.w3.org/2000/svg',
  version: '1.1',
  viewBox: '0 0 512 512',
  width: props.fontSizeEnabled ? 22 * percentageSize : 22,
  height: props.fontSizeEnabled ? 22 * percentageSize : 22,
  fill: window.innerWidth > 768 ? (props.isHover ? '#febf00' : 'white') : 'white'
}))``;

export const ShrinkLlegendaSvg = styled.svg.attrs((props) => ({
  xmlns: 'http://www.w3.org/2000/svg',
  version: '1.1',
  viewBox: '0 0 512 512',
  width: props.fontSizeEnabled ? 22 * percentageSize : 22,
  height: props.fontSizeEnabled ? 22 * percentageSize : 22,
  fill: window.innerWidth > 768 ? (props.isHover ? '#febf00' : 'white') : 'white'
}))``;

export const OcultarLlegendaSvg = styled.svg.attrs((props) => ({
  xmlns: 'http://www.w3.org/2000/svg',
  version: '1.1',
  viewBox: '0 0 512 512',
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  x: '0px',
  y: '0px',
  width: props.fontSizeEnabled ? 24 * percentageSize : 24,
  height: props.fontSizeEnabled ? 24 * percentageSize : 24,
  fill: window.innerWidth > 768 ? (props.isHover ? '#febf00' : 'white') : 'white'
}))``;

export const MostrarLlegendaSvg = styled.svg.attrs((props) => ({
  xmlns: 'http://www.w3.org/2000/svg',
  version: '1.1',
  viewBox: '0 0 512 512',
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  x: '0px',
  y: '0px',
  width: props.fontSizeEnabled ? 24 * percentageSize : 24,
  height: props.fontSizeEnabled ? 24 * percentageSize : 24,
  fill: window.innerWidth > 768 ? (props.isHover ? '#febf00' : 'white') : 'white'
}))``;
